import React from "react";

import { Image, StyleSheet, View } from "@react-pdf/renderer";

import ratingFlagIcon from "@assets/icons/rating-flag.png";
import ratingHeartIcon from "@assets/icons/rating-heart.png";
import ratingMehIcon from "@assets/icons/rating-meh.png";
import ratingThinkIcon from "@assets/icons/rating-think.png";
import ratingThumbIcon from "@assets/icons/rating-thumbs.png";

interface MealRatingIconPDFProps {
  rating: number | null | undefined;
}

const MealRatingIconPDF: React.FC<MealRatingIconPDFProps> = ({ rating }) => {
  switch (rating) {
    case 5:
      return <Image src={ratingHeartIcon} style={styles.icon} />;
    case 4:
      return <Image src={ratingThumbIcon} style={styles.icon} />;
    case 3:
      return <Image src={ratingThinkIcon} style={styles.icon} />;
    case 2:
      return <Image src={ratingMehIcon} style={styles.icon} />;
    case 1:
      return <Image src={ratingFlagIcon} style={styles.icon} />;
    default:
      return <View />;
  }
};

export default MealRatingIconPDF;

const styles = StyleSheet.create({
  icon: {
    height: 16,
    width: 16,
  },
});
